document.addEventListener('DOMContentLoaded', function () {
  const trigger = document.getElementById('customer-block');
  const popup = document.querySelector('.customer-links-wrapper');
  const overlay = document.querySelector('.customer-popup-overlay');
  const closeBtn = document.querySelector('.customer-popup-close');

  trigger?.addEventListener('click', () => {
    popup.classList.add('active');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  });

  function closePopup() {
    popup.classList.remove('active');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  closeBtn?.addEventListener('click', closePopup);
  overlay?.addEventListener('click', closePopup);
});